import { CartAddEvent } from '@theme/events';

/**
 * StoreHero: カートの種類が「ページ」のとき、カートに追加したらカートページへ移動する。
 * layout/theme.liquid で cart_type == 'page' のときだけ読み込む（ドロワーのときは cart-drawer.js がドロワーを開く）。
 */

/** 「追加済み」の表示と、カート追加の計測が送られるのを待つ時間 */
const REDIRECT_DELAY_MS = 300;

/**
 * @returns {string} カートページの URL
 */
function getCartUrl() {
  return typeof Theme !== 'undefined' && Theme.routes?.cart_url ? Theme.routes.cart_url : '/cart';
}

document.addEventListener(CartAddEvent.eventName, (event) => {
  // 数量変更などの CartUpdateEvent も同じイベント名で届くため、追加だけに絞る
  if (!(event instanceof CartAddEvent)) return;
  // 在庫不足などで追加できなかったときは移動しない
  if (event.detail?.data?.didError) return;
  // テーマエディタでは移動しない
  if (window.Shopify?.designMode) return;

  const cartUrl = getCartUrl();
  if (window.location.pathname === new URL(cartUrl, window.location.origin).pathname) return;

  window.setTimeout(() => window.location.assign(cartUrl), REDIRECT_DELAY_MS);
});
